import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { Stack, Typography } from "@mui/joy";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BrowserRouterConstants } from "../../../utils/constants";
import { BuyNowPaylaterService } from "../../../services/buy-now-paylater.service";
import { useEffect, useState } from "react";
import { MyLimit } from "../../../types/buy-now-paylater";
import { formatCurrencyByCode } from "../../../utils/formatPrice";
import { getActiveBusiness } from "../../../store/session";

export default function BNPLCard() {
  const { t } = useTranslation();
  const [data, setData] = useState<MyLimit | null>();
  const business = getActiveBusiness();

  const fetchMyLimit = () => {
    BuyNowPaylaterService.getMyLimit().then((res) => {
      if (res) {
        setData(res);
      }
    });
  };

  useEffect(() => {
    fetchMyLimit();
  }, []);

  return (
    <div className="w-full lg:max-w-[570px] flex flex-col bg-white rounded-2xl overflow-hidden shadow-lg ">
      <div className="flex flex-col gap-2 p-4">
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <p className="text-[#101828] text-base font-semibold ">
            {t("dashboard.bizPayLater")}
          </p>
          <p className="px-2 py-1 bg-[#C31D1D] rounded-md text-white">
            {"New"}
          </p>
        </Stack>
        <div className="flex items-center">
          {data && Object.keys(data).length > 0 && data.isActive ? (
            <div className="flex flex-col flex-1 gap-2">
              <p className="text-xs font-normal text-[#475467]">
                {t("finance.activatedLanding.remainingCredit")}
              </p>
              <Stack
                direction={{ xs: "column", lg: "row" }}
                alignItems={{ xs: "flex-start", lg: "center" }}
                gap={1}
                paddingTop={1}
              >
                <span className="text-2xl font-bold text-[#101828]">
                  {formatCurrencyByCode(data.remainingLimit, data.currency)}
                </span>
                <span className="text-[16px] font-normal text-[#98A2B3] pt-1">
                  {"/ "}{" "}
                  {formatCurrencyByCode(data.startingLimit, data.currency)}
                </span>
              </Stack>
            </div>
          ) : (
            <div className="flex flex-col flex-1 gap-2">
              {business?.companyCountry == "ID" ? (
                <>
                  <p className="text-[#D0D5DD] text-2xl font-bold ">
                    {"~ IDR 20.000.000"}
                  </p>

                  <Typography fontSize={12} fontWeight={400}>
                    <Trans
                      i18nKey="dashboard.activateBizPayLater"
                      values={{ currency: "IDR", amount: "20.000.000" }}
                      components={{ strong: <strong /> }}
                    />
                  </Typography>
                </>
              ) : (
                <p className="text-[#D0D5DD] text-2xl font-bold ">
                  {t("commons.comingSoon.title")}
                </p>
              )}
            </div>
          )}

          {data && Object.keys(data).length <= 0 && (
            <Link
              to={`${BrowserRouterConstants.ContactUs}?text=${t(
                "dashboard.contactUsText"
              )}`}
              target="_blank"
              className="bg-[#499873] px-4 py-[10px] rounded-lg text-white text-sm font-semibold"
            >
              {t("dashboard.contactUs")}
            </Link>
          )}
        </div>
      </div>
      <Link
        to={BrowserRouterConstants.BizPayLaterLink}
        className="flex items-center justify-between text-[#499873] py-2 px-4 bg-[#F9FAFB] cursor-pointer
        "
      >
        <p className="py-[10px] text-sm font-semibold">
          {data && Object.keys(data).length <= 0
            ? t("dashboard.bizPayLaterLink")
            : t("dashboard.activatedBizPayLaterLink")}
        </p>
        <ChevronRightIcon className="w-6 h-6" />
      </Link>
    </div>
  );
}
